import { useQuery } from '@tanstack/react-query';

import {
  getBalancesAggregatedApi,
  getTransactionsAggregatedApi,
} from '../-api/api';

export function useBalances() {
  return useQuery({
    queryKey: ['balances'],
    queryFn: () => getBalancesAggregatedApi(),
  });
}

export function useTransactionsAggregated(
  asset: string,
  direction?: 'in' | 'out',
) {
  return useQuery({
    queryKey: ['transactions', asset, direction],
    queryFn: () => getTransactionsAggregatedApi(asset, direction),
    enabled: !!asset,
  });
}
